// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".portfolio-text[data-v-395a0568]{margin:20px auto;text-align:center;width:218px;position:relative;overflow:hidden}.portfolio-text[data-v-395a0568] .ellipsis{display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
